import React, { useEffect, useRef } from 'react'
import { isCustomInfoEnabled, isAutoOpenUrl } from "../../util/helpers";

const CustomInfo = (props) => {
  const { obj } = props;
  const objtest = {
    event_type: "AGENT_ANSWER",
    business_call_type: "Outbound",
    agent_number: "poojaaaHA3@webrtchablr.knowlarity.com",
    call_recording: null,
    knowlarity_number: "+917625071322",
    uuid: "2735b699-c935-4c0b-b880-d6a7748cc800",
    call_direction: "Outbound",
    caller: "+100000000000",
    customer_number: "+100000000000",
    version: "1.0",
    k_number: "+917625071322",
    type: "AGENT_ANSWER",
    unique_id: "288b696a-39ec-49fd-bf99-25f145a41e13",
    call_solution: "obdcc",
    FreeSWITCH_IPv4: "10.60.30.151",
    variable_cc_queue: "97046108-af4a-4b0c-a91f-2b61f56d6e4a",
    Event_Date_Local: "2022-04-21 14:13:55",
    variable_sip_call_id: "02644fb9-3bf2-123b-088d-48df37d38658",
    Caller_Channel_Created_Time: "1650530630996675",
    Caller_Channel_Progress_Media_Time: "0",
    Channel_Name: "sofia/second_internal/poojaaaHA3@webrtchablr.knowlarity.com",
    variable_ivr_refnum: "1000072302",
    variable_campaign_id: "49883267",
    SR_Text_Lead: "pooja",
    SR_Link_Lead: "www.google.com",
  };
  const is_show_custom_info = isCustomInfoEnabled();
  const is_auto_open_url = isAutoOpenUrl();

  //const [customIndo,setCustomInfo] = useState(false)

  // const customUrlRef = useRef(null);

  // useEffect(() => {
  //   if (is_auto_open_url&& customUrlRef.current) {
  //     customUrlRef.current.click();
  //   }
  // }, [customUrlRef]);

  var show_custom_info = false;

  if (is_show_custom_info) {
    let sr_link_key = "";
    let sr_text_key = "";
    Object.keys(obj).map(function(key, index) {
      let sr_link = key.includes("SR_Link_");
      let sr_text = key.includes("SR_Text_");
      if (sr_link) {
        sr_link_key = key;
      }
      if (sr_text) {
        sr_text_key = key;
      }
    });

    let sr_link_value = sr_link_key ? sr_link_key.split("SR_Link_")[1] : "";
    let regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    sr_link_key =
      sr_link_key && !regex.test(obj[sr_link_key].charAt(0)) ? sr_link_key : "";
    sr_text_key =
      sr_text_key && !regex.test(obj[sr_text_key].charAt(0)) ? sr_text_key : "";

    if (sr_link_key && sr_text_key) {
      show_custom_info = (
        <>
          <div style={{ textAlign: "center" }}>
            <a
              rel="noreferrer"
              id="custom_url"
              href={obj[sr_link_key]}
              target="_blank"
              style={{ textAlign: "center" }}
            >
              {sr_link_value}
            </a>
          </div>
          <div style={{ textAlign: "center" }}>{obj[sr_text_key]}</div>
        </>
      );
    } else if (sr_link_key) {
      show_custom_info = (
        <>
          <div style={{ textAlign: "center" }}>
            <a
              rel="noreferrer"
              id="custom_url"
              href={obj[sr_link_key]}
              target="_blank"
              style={{ textAlign: "center" }}
            >
              {sr_link_value}
            </a>
          </div>
        </>
      );
    } else if (sr_text_key) {
      show_custom_info = (
        <>
          <div style={{ textAlign: "center" }}>{obj[sr_text_key]}</div>
        </>
      );
    } else {
      show_custom_info = false;
    }
  }
  return (
    <>
      {show_custom_info && (
        <div
          className="row justify-content-center mb-4"
          style={{ flexDirection: "column" }}
        >
          {show_custom_info}
        </div>
      )}
    </>
  );
};

export default CustomInfo;
